var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_660_7111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 0.643066H4.49972C2.36949 0.643066 0.642578 2.36997 0.642578 4.50021V13.5002C0.642578 15.6305 2.36949 17.3574 4.49972 17.3574H13.4997C15.63 17.3574 17.3569 15.6305 17.3569 13.5002V4.50021C17.3569 2.36997 15.63 0.643066 13.4997 0.643066Z",
    stroke: "#EFBC51",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7504 6.10742L7.60756 12.536L5.03613 10.6074",
    stroke: "#EFBC51",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_660_7111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTick);
export default __webpack_public_path__ + "static/media/Check-Tick.9fd726095176934dc9631b68372074e9.svg";
export { ForwardRef as ReactComponent };